const EXCHANGE_TOKEN = 'exchangeToken';
export const UrlExchangeTokenStorage = {
    getExchangeToken() {
        const url = new URL(window.location.href);
        const exchangeToken = url.searchParams.get(EXCHANGE_TOKEN);
        if (exchangeToken) {
            // Remove ExchangeToken from URL
            url.searchParams.delete(EXCHANGE_TOKEN);
            window.history.replaceState({}, null, url.href);
            return exchangeToken;
        }
        return null;
    },
};
export const LocalStorageTokenStorage = {
    getJwt() {
        return window.localStorage.getItem('uxa:jwt');
    },
    storeJwt(jwt) {
        window.localStorage.setItem('uxa:jwt', jwt);
    },
};
//# sourceMappingURL=app.context.services.js.map